// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Boq1","buttons":"Footer_buttons__1O6hU"};